import {callIfFn} from "src/components/Planner/planner/history";
import { PlannerAction } from "src/components/Planner/planner/history/planner-action";
import {ts} from "src/utils/translate"
import { setAndSendSerialPosition } from "src/components/Planner/planner/uDev-dom";
import {redrawDevices} from "src/components/Planner/planner/deviceDrawing";
import { getSerialConnectionForSerialId } from "src/components/Planner/planner/serialConnections";
import { connectSerials, detachSerialConnection } from "src/components/Planner/planner/serialConnections-dom";

export class ConnectSerialsAction extends PlannerAction {
  /**
   *
   * @param {number} srcSerId
   * @param {number} tarSerId
   * @param {{srcSer: {x: number, y: number, angle: number, height: number}, tarSer: {x: number, y: number, angle: number, height: number}}} prePos
   */
  constructor(srcSerId, tarSerId, prePos) {
    super();
    this.actionName = ts("p_do_action_connectframes", "Connecting frames");
    this.srcSerId = srcSerId;
    this.tarSerId = tarSerId;
    this.prePos = prePos;
  }
  execute(callback) {
    setAndSendSerialPosition(this.srcSerId, this.prePos.srcSer);
    setAndSendSerialPosition(this.tarSerId, this.prePos.tarSer);
    connectSerials(this.srcSerId, this.tarSerId)
    .then(() => {
      redrawDevices();
      callIfFn(callback, true);
    })
    .catch(() => {
      callIfFn(callback, false);
    })
  }
  undo(callback) {
    const conn = getSerialConnectionForSerialId(this.srcSerId);
    if (conn) {
      detachSerialConnection(conn.id)
      .then(() => {
        Promise.all([
          setAndSendSerialPosition(this.srcSerId, this.prePos.srcSer),
          setAndSendSerialPosition(this.tarSerId, this.prePos.tarSer)
        ])
        .then(() => {
          redrawDevices();
          callIfFn(callback, true);
        })
        .catch(() => {
          callIfFn(callback, false);
        });
      })
      .catch(() => {
        callIfFn(callback, false);
      });
    }
    else {
      callIfFn(callback, false);
    }
  }

  serialIdChanged(from, to) {
    if (this.equalAsString(from, this.srcSerId)) {
      this.srcSerId = to;
    }
    if (this.equalAsString(from, this.tarSerId)) {
      this.tarSerId = to;
    }
  }
}

export class DisconnectSerialsAction extends PlannerAction {
  /**
   *
   * @param {number} srcSerId
   * @param {number} tarSerId
   * @param {{x: number, y: number, angle: number, roomId: number}} prePos
   */
  constructor(srcSerId, tarSerId, prePos) {
    super();
    this.actionName = ts("p_do_action_disconnframes", "Disconnecting frames");
    this.srcSerId = srcSerId;
    this.tarSerId = tarSerId;
    this.prePos = prePos;
  }
  execute(callback) {
    const conn = getSerialConnectionForSerialId(this.srcSerId);
    if (conn) {
      detachSerialConnection(conn.id)
      .then(() => {
        callIfFn(callback, true);
      })
      .catch(() => {
        callIfFn(callback, false);
      });
    }
    else {
      callIfFn(callback, false);
    }
  }
  undo(callback) {
    Promise.all([
      setAndSendSerialPosition(this.srcSerId, this.prePos),
      setAndSendSerialPosition(this.tarSerId, this.prePos),
      connectSerials(this.srcSerId, this.tarSerId)
    ])
    .then(() => {
      callIfFn(callback, true);
    })
    .catch(() => {
      callIfFn(callback, false);
    });
  }
  serialIdChanged(from, to) {
    if (this.equalAsString(from, this.srcSerId)) {
      this.srcSerId = to;
    }
    if (this.equalAsString(from, this.tarSerId)) {
      this.tarSerId = to;
    }
  }
}

